export const getQueryStringValue = (key) => {
  const url = new URL(window.location.href);
  return url.searchParams.get(key);
};

export const formatDate = (date) => {
  let d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [month, day, year].join('-');
};

export const parseDate = (date) => {
  const [mm, dd, yyyy] = date.split('-');
  return new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
};
